import { DateTime } from "luxon";

const forLocal = () => {
  return DateTime.local().zoneName;
};

export const getTimezone = { forLocal };
